module.exports = __webpack_public_path__ + "static/media/CRV-ETH.8e22a111.png";